import React, { useCallback } from "react";

import { useTheme } from "context/ThemeContext";
import BadgeofEthicsLight from "images/Badge-of-Ethics-02.inline.svg";
import BadgeofEthicsDark from "images/do_good_better_dark.inline.svg";
import EthicsCollaborateIcon from "images/icons/ethics-icon-collaborate.inline.svg";
import EthicsInfiniteIcon from "images/icons/ethics-icon-infinite.inline.svg";
import EthicsOrphanageIcon from "images/icons/ethics-icon-orphanage.inline.svg";
import EthicsOwnershipIcon from "images/icons/ethics-icon-ownership.inline.svg";
import EthicsReportingIcon from "images/icons/ethics-icon-reporting.inline.svg";
import EthicsRespectIcon from "images/icons/ethics-icon-respect.inline.svg";
import EthicsRolesIcon from "images/icons/ethics-icon-roles.inline.svg";
import EthicsStrategyIcon from "images/icons/ethics-icon-strategy.inline.svg";
import EthicsTargetIcon from "images/icons/ethics-icon-target.inline.svg";
import EthicsVulnerableIcon from "images/icons/ethics-icon-vulnerable.inline.svg";
import EthicsIcon from "images/icons/ethics-icon.inline.svg";
import { Link } from "utils/customLink";

const OurEthics = ({ ourEthics }) => {
  const { colorMode } = useTheme();

  const iconByName = useCallback((iconName) => {
    const ethicsClass =
      "ethics object-center object-contain w-4 h-4 fill-yellow-lighten planet:fill-white";

    switch (iconName) {
      case "collaborate":
        return <EthicsCollaborateIcon className={ethicsClass} />;

      case "infinite":
        return <EthicsInfiniteIcon className={ethicsClass} />;

      case "orphanage":
        return <EthicsOrphanageIcon className={ethicsClass} />;

      case "ownership":
        return <EthicsOwnershipIcon className={ethicsClass} />;

      case "reporting":
        return <EthicsReportingIcon className={ethicsClass} />;

      case "respect":
        return <EthicsRespectIcon className={ethicsClass} />;

      case "roles":
        return <EthicsRolesIcon className={ethicsClass} />;

      case "strategy":
        return <EthicsStrategyIcon className={ethicsClass} />;

      case "target":
        return <EthicsTargetIcon className={ethicsClass} />;

      case "vulnerable":
        return <EthicsVulnerableIcon className={ethicsClass} />;

      default:
        return <EthicsIcon className={ethicsClass} />;
    }
  }, []);

  return (
    <>
      <h2 className="heading text-left py-5">{ourEthics.ourEthicsHeading}</h2>

      <div className="divide-y width-divider" />

      <div
        className="planet:gvi-light-gray-text  text-black-lighter text-sm pt-5 tab-content_html"
        dangerouslySetInnerHTML={{ __html: ourEthics.ourEthicsIntroduction }}
      />

      {colorMode === "light" ? (
        <BadgeofEthicsDark className="ethics-badge-dark object-center object-contain my-5 " />
      ) : (
        <BadgeofEthicsLight className="ethics-badge-light object-center object-contain my-5" />
      )}

      <h3 className="heading text-left py-3 text-black-lighter">
        Our 10 ethical commitments
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-3">
        {ourEthics.ourEthicalCommitments.map((commitment, idx) => (
          <div
            key={`commitment-${idx}`}
            className="bg-secondary-bg planet:gvi-light-gray-bg p-5 h-full rounded-xs relative"
          >
            <div className="flex bg-white planet:gvi-gray-bg w-min p-2 rounded-xxs">
              <span className="flex items-center px-1">
                {iconByName(commitment.ourEthicalCommitmentsIcon)}
              </span>
              <h3 className="font-semibold text-sm flex flex-col flex-1 border-0 border-l border-gray-lighter !py-0 !px-1">
                {idx < 9 ? `0${idx + 1}` : idx + 1}
              </h3>
            </div>
            <div className="commitment-heading">
              <h3
                className="font-semibold text-sm py-3"
                dangerouslySetInnerHTML={{
                  __html: commitment.ourEthicalCommitmentsCommittmentHeading
                }}
              />
              <div
                className="planet:gvi-light-gray-text text-black-lighter text-sm tab-content_html"
                dangerouslySetInnerHTML={{
                  __html: commitment.ourEthicalCommitmentsCommitmentBrief
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <h3 className="heading text-left py-3 text-black-lighter">
        {ourEthics.ourEthicsHeadingOutro}
      </h3>

      <div
        className="planet:gvi-light-gray-text text-black-lighter text-sm tab-content_html"
        dangerouslySetInnerHTML={{ __html: ourEthics.ourEthicsBriefOutro }}
      />

      <Link
        className="text-base font-bold underline text-white mt-6  hidden"
        to="#"
      >
        Read Program Ethics next
      </Link>
    </>
  );
};

export default OurEthics;
